import LibraryDetailsItem from "../library-details-item.jsx";
import ProjectUtils from "../../../../../../utils/project-utils.js";
import {getFileType, imageExtensions} from "../../../utils/library-utils.js";

export default function LibraryTypeFile({ item }) {
    const size = `${ProjectUtils.formatFileSize(item.attachSize)}`;

    return (
        <div className="space-y-2 mt-2">
            <LibraryDetailsItem>Tipo de arquivo: {getFileType(item.attachExtension)}</LibraryDetailsItem>
            <LibraryDetailsItem>Extensão: {item.attachExtension}</LibraryDetailsItem>
            <LibraryDetailsItem>Tamanho: {size}</LibraryDetailsItem>
        </div>
    )
}